import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService } from '../services/index';
import { FileUploadService } from '../services/file-upload.service';

@Injectable()
export class SplUploadResolverService implements Resolve<any> {
  customerGuid: string;

  constructor(private storageManagerService: StorageManagerService,
    private fileUploadService: FileUploadService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
      const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
      if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
      }
    }

    const retVal = forkJoin([
      this.fileUploadService.fetchUploadedFileHistory('1 Year')])
      .pipe(catchError(err => of(err)));
      return retVal;
    }
}
